import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';

import Homepage from '../src/pages/Homepage/HomePage';

function App() {
  return (
    <div>
      <Router>
        <Homepage />
      </Router>
    </div>
  );
}

export default App;
